module.exports = __webpack_public_path__ + "static/upsell-a83a5b2a1ed85c46d824337d7da5bc00.png";